module.exports = __webpack_public_path__ + "static/media/grip-lines-vertical.500c5c27.svg";